import { createContext } from "@videojs/element/context";
/** @internal */
const sliderContext = createContext(Symbol("@videojs/slider"));
//#endregion
export { sliderContext };

//# sourceMappingURL=context.js.map